import config from '../config';
import selectedEnvironment from '../env';

const BASEAPI = config[selectedEnvironment].API_URL;
const ROOT = `${BASEAPI}/Releases`;

// The header mounts on almost every page, so the feed is cached briefly.
const CACHE_TTL_MS = 5 * 60 * 1000;
let cache = { at: 0, data: null, pending: null };

const getCurrentToken = () => {
    const token = localStorage.getItem('token');
    return token != null ? JSON.parse(token) : null;
};

export const FEED_PAGE_SIZE = 20;

const fetchFeed = async (offset = 0) => {
    const res = await fetch(`${ROOT}/feed?batch=${FEED_PAGE_SIZE}&offset=${offset}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getCurrentToken()}`,
        },
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok || json?.success === false) {
        throw new Error(json?.error || `HTTP ${res.status}`);
    }
    return Array.isArray(json?.data) ? json.data : [];
};

const ReleaseService = {
    /** First page of Work + Public releases for the "What's new" panel. */
    getFeed: async ({ force = false } = {}) => {
        const fresh = cache.data && Date.now() - cache.at < CACHE_TTL_MS;
        if (!force && fresh) return cache.data;
        if (cache.pending) return cache.pending;

        cache.pending = fetchFeed()
            .then((data) => {
                cache = { at: Date.now(), data, pending: null };
                return data;
            })
            .catch((err) => {
                cache.pending = null;
                throw err;
            });
        return cache.pending;
    },

    /** Older pages, fetched on demand when the user scrolls past the first page. */
    getFeedPage: (offset) => fetchFeed(offset),
};

export const RELEASE_MEDIA = { None: 0, Image: 1, Gif: 2, Video: 3 };

export default ReleaseService;
